import type { SvgWrapperProps } from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import type { Layout } from '@ipfabric/utils';
import { CircularIcon } from 'components/Graph/GraphLayout/icons/CircularIcon';
import { DownwardTreeIcon } from 'components/Graph/GraphLayout/icons/DownwardTreeIcon';
import { HierarchicalIcon } from 'components/Graph/GraphLayout/icons/HierarchicalIcon';
import { RadialIcon } from 'components/Graph/GraphLayout/icons/RadialIcon';
import { UniversalIcon } from 'components/Graph/GraphLayout/icons/UniversalIcon';
import { UpwardTreeIcon } from 'components/Graph/GraphLayout/icons/UpwardTreeIcon';
import { UserDefinedIcon } from 'components/Graph/GraphLayout/icons/UserDefinedIcon';
import { forwardRef } from 'react';

type Props = SvgWrapperProps & {
  layout: Layout;
};

// All icon types are the same and pretty tricky to declare, so we just pick the type from one of them.
const layoutIconComponents: { [Key in Layout]: typeof CircularIcon } = {
  circular: CircularIcon,
  hierarchical: HierarchicalIcon,
  userDefined: UserDefinedIcon,
  upwardTree: UpwardTreeIcon,
  downwardTree: DownwardTreeIcon,
  universal: UniversalIcon,
  radial: RadialIcon,
};

export const GraphLayoutIcon = forwardRef<SVGSVGElement, Props>(
  (props, ref) => {
    const IconComponent = layoutIconComponents[props.layout];
    return <IconComponent ref={ref} {...props} />;
  },
);

GraphLayoutIcon.displayName = 'GraphLayoutIcon';
